import React from 'react'
import { useIntl } from 'react-intl'
import { Calendar } from 'primereact/calendar'
import { addLocale } from 'primereact/api'
import './calendarComp.scss'

const CalendarComp = ({
  name,
  value,
  onChange,
  disabled,
  showTime,
  hourFormat,
  maxDate,
  minDate,
  placeholder = null,
  showButtonBar,
  className,
}) => {
  const { formatMessage: msg } = useIntl()

  //TODO; translate
  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
    ],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    weekHeader: 'SEM',
    monthNames: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    monthNamesShort: [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic',
    ],
    today: 'Hoy',
    clear: 'Limpiar',
  })

  return (
    <Calendar
      name={name}
      value={value ? new Date(value) : ''}
      onChange={(e) => onChange(e)}
      showWeek
      locale="es"
      disabled={disabled}
      dateFormat="dd/mm/yy"
      showButtonBar={showButtonBar}
      showIcon
      showTime={showTime}
      hourFormat={hourFormat}
      maxDate={maxDate}
      minDate={minDate}
      placeholder={placeholder ? msg({ id: placeholder }) : ''}
      className={className}
    />
  )
}
export default CalendarComp
